import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // Optional
  variant?: string;
  size?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset'; // Restrict to valid HTML button types
  className?: string;
  [key: string]: any; // For additional props
}

const Buttons: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseStyles = 'font-poppins font-semibold transition-colors';
  const variantStyles =
    variant === 'primary'
      ? 'bg-[#008EA0] text-white hover:bg-[#007A8A]'
      : 'bg-transparent text-white border border-[#008EA0] hover:bg-[#008EA0] hover:text-white';
  const sizeStyles =
    size === 'small' ? 'px-4 py-2 text-sm' : size === 'large' ? 'px-8 py-4 text-lg' : 'px-6 py-3 text-base';
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button data-component-id="src\components\ui\Button.tsx:34:4" data-component-path="src\components\ui\Button.tsx" data-component-line="34" data-component-file="Button.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles} ${sizeStyles} ${disabledStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Buttons;